module.exports = __webpack_public_path__ + "885d4190c02e1b51b385fd03887b3a2f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/s/s06.jpg
// module id = 682
// module chunks = 0